import { FC, useEffect, useState } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { isSafari } from '@telialt/utils/src/helpers';

import { DOWNLOAD_CONTRACT_SUMMARY_TEST_ID } from '../constants';
import { SmallerButton } from './TriggerDownloadButton.styles';

type Props = {
    onClick: () => void;
    isLoading: boolean;
    textToDownload?: string;
    textToGenerate?: string;
    className?: string;
    isNegative: boolean;
};

export const TriggerDownloadButton: FC<Props> = ({
    isLoading,
    onClick,
    className,
    isNegative,
    textToDownload: textToDownloadInit,
    textToGenerate: textToGenerateInit,
}) => {
    const { t } = useTranslations();
    const textToDownload = textToDownloadInit || t['plans.detailed_offer'];
    const textToGenerate = textToGenerateInit || t['plans.detailed_offer_download'];

    const [isSafariBrowser, setIsSafariBrowser] = useState(false);
    useEffect(() => {
        setIsSafariBrowser(isSafari());
    }, []);

    return (
        <SmallerButton
            onClick={onClick}
            loading={isLoading}
            disabled={isLoading}
            negative={isNegative}
            className={className}
            data-test={DOWNLOAD_CONTRACT_SUMMARY_TEST_ID.DOWNLOAD_BUTTON}
        >
            {isSafariBrowser ? textToGenerate : textToDownload}
        </SmallerButton>
    );
};
